var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_425",
    "data-name": "Grupo 425",
    transform: "translate(-467 -211)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_57",
    "data-name": "Elipse 57",
    cx: 30.5,
    cy: 30.5,
    r: 30.5,
    transform: "translate(467 211)",
    fill: "#f9fafc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "help_outline_black_24dp_1_",
    "data-name": "help_outline_black_24dp (1)",
    transform: "translate(476 220)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_548",
    "data-name": "Trazado 548",
    d: "M0,0H44V44H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_549",
    "data-name": "Trazado 549",
    d: "M22,2A20,20,0,1,0,42,22,20.007,20.007,0,0,0,22,2Zm0,36A16,16,0,1,1,38,22,16.021,16.021,0,0,1,22,38Zm-2-8h4v4H20Zm3.22-19.92a8,8,0,0,0-8.86,5.58A1.814,1.814,0,0,0,16.1,18h.4a1.925,1.925,0,0,0,1.76-1.34,4,4,0,0,1,4.6-2.56A4.046,4.046,0,0,1,26,18.3c-.2,2.68-3.24,3.26-4.9,5.76,0,.02-.02.02-.02.04-.02.04-.04.06-.06.1a6.663,6.663,0,0,0-.5,1c-.02.06-.06.1-.08.16a1.275,1.275,0,0,0-.04.14A7.435,7.435,0,0,0,20,28h4a4.249,4.249,0,0,1,.56-2.14c.04-.06.06-.12.1-.18a5.516,5.516,0,0,1,.56-.78c.02-.02.04-.06.06-.08a7.029,7.029,0,0,1,.66-.68c1.92-1.82,4.52-3.3,3.98-7.12a8.15,8.15,0,0,0-6.7-6.94Z",
    fill: "#3264dc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.352d543fb719f16b2d60d1fec6cd0b25.svg";
export { ForwardRef as ReactComponent };